/* eslint-disable no-unused-vars */
import {
  LinkOutlined,
  MailOutlined,
  MoreOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { TEXT, UNASSIGNED_LABEL } from '@moxie/constants';
import { Button, popConfirm } from '@shared-components/elements';
import { ITableNameCardProps } from '@shared-components/models';
import { Col, Dropdown, Row, Space, Tooltip, Typography } from 'antd';
import Avatar from 'antd/lib/avatar/avatar';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const { Text, Paragraph } = Typography;

export const UnassignedCard: React.FC = () => {
  return (
    <Space className="lead-table__name user-name-card">
      <Col className="align-items-center  user-name-card__avatar">
        <Avatar icon={<UserOutlined />} alt="unassigned" />
      </Col>
      <Col className="user-name-card__name ">
        <Typography.Text type="secondary">{UNASSIGNED_LABEL}</Typography.Text>
      </Col>
    </Space>
  );
};
export const UserNameCard: React.FC<ITableNameCardProps> = ({
  firstName,
  lastName,
  email,
  index,
  actionBar,
  link,
  menu,
  showEmailAsLink,
  showMailIcon,
  size,
  typeOption,
  handleEdit,
}: ITableNameCardProps) => {
  const [ellipsis, setEllipsis] = useState(true);
  const [isCopied, setIsCopied] = useState(false);
  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
    setIsCopied(true);
  };
  return (
    <Row className="lead-table__name user-name-card">
      <div className="align-items-center user-name-card__avatar initial_capital">
        {link ? (
          <Link to={link}>
            <Avatar size={size}>
              {firstName?.substring(0, 1)}
              {lastName?.substring(0, 1).toUpperCase()}
            </Avatar>
          </Link>
        ) : (
          <div onClick={handleEdit && handleEdit}>
            <Avatar size={size}>
              {firstName?.substring(0, 1)}
              {lastName?.substring(0, 1).toUpperCase()}
            </Avatar>
          </div>
        )}
      </div>
      <Col className="user-name-card__name">
        <div key={index}>
          <Col className="initial_capital">
            {link ? (
              <Link to={link}>
                <Text className="text-primary-color">{`${firstName} ${lastName}`}</Text>
              </Link>
            ) : (
              <>
                {showMailIcon ? (
                  <Tooltip title={TEXT.CLICK_SELECT_ASSIGNEE}>
                    <Col
                      onClick={handleEdit && handleEdit}
                      className="lead__hover-color"
                    >
                      <Text>{`${firstName} ${lastName}`}</Text>
                    </Col>
                  </Tooltip>
                ) : (
                  <Col onClick={handleEdit && handleEdit}>
                    <Text>{`${firstName} ${lastName}`}</Text>
                  </Col>
                )}
              </>
            )}
          </Col>
          <Col>
            <Row className="email_div">
              {showEmailAsLink === true ? (
                <>
                  {showMailIcon && (
                    <Col>
                      <a href={`mailto:${email}`}>
                        {' '}
                        <MailOutlined className="table-mail-icon" />{' '}
                      </a>
                    </Col>
                  )}
                  <Col lg={19}>
                    <small className="table-elements-email-container">
                      <a
                        className="text-primary-color"
                        href={`mailto:${email}`}
                      >
                        <Paragraph
                          ellipsis={
                            ellipsis ? { tooltip: `${email}` } : undefined
                          }
                          className="text-primary-color"
                        >
                          {email?.toLowerCase()}
                        </Paragraph>
                      </a>
                    </small>
                  </Col>
                </>
              ) : (
                <Col lg={18}>
                  <small>
                    <Paragraph
                      className="assigned-user-email text-primary-color"
                      ellipsis={ellipsis ? { tooltip: `${email}` } : undefined}
                    >
                      {email?.toLowerCase()}
                    </Paragraph>
                  </small>
                </Col>
              )}
              {showEmailAsLink && (
                <Col className="hide">
                  <Tooltip
                    className=" margin-left-1 "
                    placement="right"
                    color={isCopied ? '#8EAF74' : '#9B9D9A '}
                    title={
                      isCopied ? `${TEXT.COPIED_SUCCESS}` : `${TEXT.COPY_EMAIL}`
                    }
                  >
                    <LinkOutlined
                      className="copy_email_icon"
                      onClick={() => copyToClipboard(`${email}`)}
                    />
                  </Tooltip>
                </Col>
              )}
            </Row>
          </Col>
        </div>
      </Col>
      {actionBar && menu !== null && (
        <Col className="user-name-card__action">
          {menu && (
            <Dropdown overlay={menu}>
              <Button
                type="text"
                className="table-cell-action-btn"
                icon={<MoreOutlined />}
              />
            </Dropdown>
          )}
        </Col>
      )}
    </Row>
  );
};
